import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import Loading from '../../components/Loading'
import { Parser } from 'html-to-react'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { store } from '../../components/HOC/State'
import { translate } from '../translate'
import { axiosInstance } from '../../const/axiosInstance'
import styles from './newsOrDec.module.css'

export default function NewsOrDecPage({category}) {
    const [el, setEl] = useState({})
    const [loading, setLoading] = useState(false)

    const  {selectedLang} = useContext(store)
    let lang = translate[selectedLang]

    const htmlParser = new Parser()

    const {id} = useParams()

    useEffect(() =>{
        (async() => {
            setLoading(true)
            const res = await axiosInstance.get(`/use/${category}/${id}`)
            if(res.data.status){
              setEl(res.data.data)
            }else{
              setEl({})
            }
            setLoading(false)
        })()
      }, [id])

  return (
      <div className={styles['news-declaration-page-main']}>
        {loading ? <Loading width={200}/> :
        <div className={styles['news-declaration-page-info']}>
            <p className={styles['news-declaration-category']}>{category !== "news" ? lang.tr_announcements : lang.tr_news}</p>
            <h2 className={styles['news-declaration-page-title']}>{el[`${selectedLang}name`]}</h2>
            <div className={styles['news-declaration-page-created']}>
                <FontAwesomeIcon icon={faCalendarDays} />
                <p>{new Date(el.created_at).toLocaleDateString()}</p>
            </div>
            <div className="material">
                {htmlParser.parse(el[`${selectedLang}information`]?.
                                replaceAll(`iframe width="auto" height="auto"`, `iframe width="${0.6*window.innerWidth}" height="${0.6*window.innerWidth/1.6}" allowfullscreen`).
                                replaceAll("alt=\"undefined\" style=\"height: auto;width: auto\"/>", `alt="undefined" "height="auto" width="${0.6*window.innerWidth}"/>`))}
            </div>
        </div>}
      </div>
  )
}
